import React, { useRef, useEffect } from 'react';
import { useCountUp } from 'react-countup';

type CountUpProps = {
  start?: number;
  end: number;
  delay?: number;
  duration?: number;
};

export const CountUpCustom: React.FC<CountUpProps> = ({ ...props }) => {
  const countUpRef = useRef<HTMLDivElement>(null);

  const { start } = useCountUp({
    ...props,
    ref: countUpRef
  });

  useEffect(()=> {
    start();
  }, []);

  return (
    <React.Fragment>
      <div ref={countUpRef} />
    </React.Fragment>
  );
};

